var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isBackground
    ? _c("div", { staticClass: "image", style: _vm._f("bgImage")(_vm.url) })
    : _c("img", {
        attrs: {
          src: _vm.url,
          srcset: _vm._f("srcset")(_vm.srcset),
          alt: _vm.alt
        }
      })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dadf800c", { render: render, staticRenderFns: staticRenderFns })
  }
}